import { Routes } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { AuthComponent } from './auth/auth.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DemographicsComponent } from './demographics/demographics.component';
import { PaymentComponent } from './payment/payment.component';
import { ChooseTheCountryComponent } from './choose-the-country/choose-the-country.component';
import { BillingComponent } from './billing/billing.component';

export const authRoutes: Routes = [
  {
    path: 'embedded/billing',
    component: AuthComponent,
    data: {
      embedded: true
    },
    children: [
      {
        path: '',
        data: {
          type: 'billing'
        },
        component: BillingComponent
      }
    ]
  },
  {
    path: 'login',
    component: AuthComponent,
    children: [
      {
        path: '',
        component: SignInComponent,
        data: {
          type: 'login'
        }
      },
      {
        path: 'location-and-game',
        component: ChooseTheCountryComponent,
        data: {
          type: 'login'
        }
      }
    ]
  },
  {
    path: 'signup',
    component: AuthComponent,
    children: [
      {
        path: '',
        data: {
          type: 'sign-up'
        },
        component: SignUpComponent
      },
      {
        path: 'demographics',
        data: {
          type: 'sign-up'
        },
        component: DemographicsComponent
      },
      {
        path: 'payment',
        data: {
          type: 'sign-up'
        },
        component: PaymentComponent
      },
      {
        path: 'location-and-game',
        component: ChooseTheCountryComponent,
        data: {
          type: 'sign-up'
        }
      }
    ]
  },
  {
    path: 'forgot-password',
    component: AuthComponent,
    children: [
      {
        path: '',
        data: {
          type: 'forgot-password'
        },
        component: ForgotPasswordComponent
      }
    ]
  }
];
